<!-- components/SiteHeader.vue -->
<template>
    <header>
      <div class="header-container">    
        <DiscountBar />
        <AccountBar />
      
        <div class="outer-header-wrap">
          <div class="site-branding" @click="navigateHome">
            <img class="logo" 
                src="~/assets/svg/forwardaudio_logo_on_black.svg" 
                alt="Forward Audio Logo"
                width="410"
                height="60"
            />
          </div>
    
          <div id="nav-wrapper">
            <Burger />
            <nav-menu class="main-menu" name="main" />
          </div>
        </div>    
      </div>
  </header>
  </template>
  
  <script setup>
  import { useRouter } from 'vue-router'
  
  const router = useRouter()
  
  const navigateHome = () => {
    router.push('/')
  }
  </script>
  
<style lang="scss" scoped>
@import '~/assets/constants.scss';
@import '~/assets/global.scss';

</style>
  